import React from 'react'
import { database, storage } from '../../Firebase/firebase';

function AdminProjectCard({id,title,description,image,imagePath, 
    techStack,
    type,
    features,
    responsibilities,
    gitLink,
    blogLink,
    hostLink}) {
    const [modalVisible, setModalVisible] = React.useState(false);
      const imageRef = React.useRef();
      const [projectDetails, setProjectDetails] = React.useState({
        title,
        description,
        techStack,
        type,
        features,
        responsibilities,
        gitLink,
        blogLink,
        hostLink,
      });

      const [uploadState, setUploadState] = React.useState(false);
    const handleDelete = () => {
        if (imagePath) storage.ref(`projects/${imagePath}`).delete();
         database.collection("projects").doc(id).delete();
    }
    const handleSubmit = (e) => {
             e.preventDefault();
             let payload = {};
             for (let key in projectDetails) {
               if (projectDetails[key]) {
                 payload[key] = projectDetails[key];
               }
             }

             if (imageRef.current?.files[0]?.name) {
               if (imageRef.current?.files[0]?.type.includes("image")) {
                 setUploadState(true);
                 if (imagePath) storage.ref(`projects/${imagePath}`).delete();
                 const uploadTask = storage
                   .ref(`projects/${imageRef.current.files[0].name}`)
                   .put(imageRef.current.files[0]);

                 uploadTask.on(
                   "state_changed",
                   (snapshot) => {
                     // setPostState(Math.floor((snapshot.bytesTransferred/snapshot.totalBytes)*100)+1)
                   },
                   (error) => {},
                   () => {
                     storage
                       .ref("projects")
                       .child(imageRef.current.files[0].name)
                       .getDownloadURL()
                       .then((url) => {
                         database.collection("projects").doc(id).update({
                           ...payload,
                           image: url,
                           imagePath: imageRef.current.files[0].name,
                         });
                         setUploadState(false);
                         setModalVisible(false);
                       });
                   }
                 );
               }
             } else{
                    setUploadState(true);
                   database.collection("projects").doc(id).update(payload).then(()=>{
                         setUploadState(false);
                         setModalVisible(false);
                   })
             }
    }
    const handleChange = (e) => {
        setProjectDetails({...projectDetails, [e.target.name]: e.target.value});
    };
    return (
      <>
        <div key={id} className="adminProjectCard flexBox">
          <img src={image} alt="pic" />
          <div>
            <h1>{title}</h1>
            <p>{description}</p>
            <div className="projectButtons">
              <button onClick={() => setModalVisible(true)}>Edit</button>
              <button onClick={handleDelete}>Delete</button>
            </div>
          </div>
        </div>
        {modalVisible && (
          <div
            className="projectEditModal flexBox"
            onClick={() => setModalVisible(false)}
          >
            <div
              className="projectEditForm addNewProject"
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className="projectEditCloseButton"
                onClick={() => setModalVisible(false)}
              >
                close <button>X</button>
              </div>
              <form
                className="projectDetails projectForm flexBox"
                onSubmit={handleSubmit}
              >
                <h1>Edit Project</h1>
                <input
                  type="text"
                  placeholder="Title"
                  name="title"
                  required
                  onChange={handleChange}
                  value={projectDetails.title}
                />
                <input type="file" ref={imageRef} />
                <textarea
                  name="description"
                  cols="30"
                  rows="3"
                  placeholder="Description"
                  required
                  onChange={handleChange}
                  value={projectDetails.description}
                />
                <input
                  name="techStack"
                  placeholder="Tech Stack"
                  required
                  onChange={handleChange}
                  value={projectDetails.techStack}
                />
                <input
                  type="text"
                  name="type"
                  placeholder="Type"
                  required
                  onChange={handleChange}
                  value={projectDetails.type}
                />
                <textarea
                  type="text"
                  placeholder="Features"
                  name="features"
                  onChange={handleChange}
                  value={projectDetails.features}
                />
                <textarea
                  type="text"
                  name="responsibilities"
                  placeholder="Responsibilities"
                  onChange={handleChange}
                  value={projectDetails.responsibilities}
                />
                <input
                  type="text"
                  name="gitLink"
                  placeholder="Git Link"
                  required
                  onChange={handleChange}
                  value={projectDetails.gitLink}
                />
                <input
                  type="text"
                  name="blogLink"
                  placeholder="Blog Link"
                  onChange={handleChange}
                  value={projectDetails.blogLink}
                />
                <input
                  type="text"
                  name="hostLink"
                  placeholder="Host Link"
                  onChange={handleChange}
                  value={projectDetails.hostLink}
                />
                <button disabled={uploadState}>UPDATE</button>
              </form>
            </div>
          </div>
        )}
      </>
    );
}

export default AdminProjectCard
